import React, { useState, useEffect } from 'react';
import { IoShareOutline } from 'react-icons/io5';
import { FaPlusSquare } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';

const IosInstallPrompt = () => {
    const [isVisible, setIsVisible] = useState(false);
    const location = useLocation();

    useEffect(() => {
        // Detects if device is on iOS 
        const isIos = () => {
            const userAgent = window.navigator.userAgent.toLowerCase();
            return /iphone|ipad|ipod/.test(userAgent);
        };

        // Detects if device is in standalone mode
        const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

        // Check if should show prompt
        if (isIos() && !isInStandaloneMode()) {
            const lastPrompt = localStorage.getItem('iosInstallPromptDate');
            const today = new Date().toISOString();

            if (!lastPrompt) {
                setIsVisible(true);
            } else {
                const daysSinceLastPrompt = (new Date(today) - new Date(lastPrompt)) / (1000 * 60 * 60 * 24);
                if (daysSinceLastPrompt > 7) {
                    setIsVisible(true);
                }
            }
        }
    }, []);

    const handleDismiss = () => {
        setIsVisible(false);
        localStorage.setItem('iosInstallPromptDate', new Date().toISOString());
    };

    if (!isVisible) return null;

    // Standalone check (redundant but safe)
    if (('standalone' in window.navigator) && (window.navigator.standalone)) return null;

    const isAuthRoute = ['/login', '/cadastro'].includes(location.pathname);
    const isPlatformRoute = location.pathname.startsWith('/plataforma');

    // Don't show on public home or other pages
    if (!isAuthRoute && !isPlatformRoute) return null;

    // Custom text for Platform
    const titleText = isPlatformRoute
        ? "Acesse mais rápido!"
        : "Instale o Sulash App";

    // Optional: Different style for Platform (Top Bar) vs Auth (Bottom Banner)
    const bannerStyle = isPlatformRoute ? { ...styles.banner, bottom: 'auto', top: 0, borderTop: 'none', borderBottom: '1px solid #FF7EAF' } : styles.banner;

    return (
        <div style={bannerStyle}>
            <div style={styles.content}>
                <div style={styles.header}>
                    <h3 style={styles.title}>{titleText}</h3>
                    <button onClick={handleDismiss} style={styles.closeButton}>&times;</button>
                </div>
                <p style={styles.instruction}>
                    Toque em Compartilhar <IoShareOutline style={styles.icon} /> e depois em Adicionar à Tela de Início <FaPlusSquare style={styles.icon} />
                </p>
                <button onClick={handleDismiss} style={styles.understandButton}>
                    Entendi
                </button>
            </div>
        </div>
    );
};

const styles = {
    banner: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        backgroundColor: '#0c0c0c',
        borderTop: '1px solid #FF7EAF',
        padding: '1.5rem',
        zIndex: 9999,
        boxShadow: '0 -4px 20px rgba(0,0,0,0.6)',
        boxSizing: 'border-box',
        color: 'white',
        fontFamily: '"Poppins", sans-serif',
    },
    content: {
        maxWidth: '500px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    title: {
        margin: 0,
        fontSize: '1.2rem',
        color: '#FF7EAF',
    },
    closeButton: {
        background: 'none',
        border: 'none',
        color: '#ccc',
        fontSize: '1.5rem',
        cursor: 'pointer',
        padding: '0 0.5rem',
    },
    instruction: {
        margin: 0,
        fontSize: '0.95rem',
        lineHeight: '1.5',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '0.3rem',
    },
    icon: {
        fontSize: '1.2rem',
        color: '#FF7EAF',
        verticalAlign: 'middle',
    },
    understandButton: {
        backgroundColor: '#FF7EAF',
        color: 'white',
        border: 'none',
        padding: '0.8rem',
        borderRadius: '8px',
        fontSize: '1rem',
        fontWeight: 'bold',
        cursor: 'pointer',
        marginTop: '0.5rem',
        width: '100%',
    },
};

export default IosInstallPrompt;
